import {Regulation} from 'types';
import {TFunction} from 'react-i18next';
import {
	renderHeaderXL,
	createZIPXL,
	renderArrayXL,
	renderRowItemAsLinkXL,
	mergeColumnsExcel,
} from './ExcelExportCommon';
import Excel from 'exceljs';
import {InfinityListColumn} from '../InfinityList';
import {XLColumn} from './ExcelExportCommon';

interface IRegulationsPage {
	(
		entityListItems: any[],
		columns: InfinityListColumn[],
		t: TFunction,
	): Promise<void>;
}

export const getColumnsXLRender = (t: TFunction) => [
	{
		key: 'attachments',
		xlName: ' ',
		xlHideFilter: true,
		xlWidth: 10,
	},
	{
		key: 'regulationNumber',
		xlRender: (iRegulation: Regulation) => iRegulation.regulationNumber,
		xlWidth: 40,
	},
	{
		key: 'name',
		xlRender: (iRegulation: Regulation) => iRegulation.name,
		xlWidth: 80,
	},
	{
		key: 'markets',
		xlRender: (iRegulation: Regulation) => renderArrayXL(iRegulation.markets),
	},
	{
		key: 'mainKeywords',
		xlRender: (iRegulation: Regulation) =>
			renderArrayXL(iRegulation.mainKeywords),
	},
	{
		key: 'keywords',
		xlRender: (iRegulation: Regulation) => renderArrayXL(iRegulation.keywords),
	},
	{
		key: 'standardPlusPcmsClusters',
		xlRender: (iRegulation: Regulation) =>
			renderArrayXL(iRegulation.standardPlusPcmsClusters),
	},
	{
		key: 'icsCodes',
		xlRender: (iRegulation: Regulation) => renderArrayXL(iRegulation.icsCodes),
	},
];

export const handleClickRegulations: IRegulationsPage = async (
	entityListItems,
	columns,
	t,
) => {
	const filtRegulation = entityListItems as Regulation[];

	const workbook = new Excel.Workbook();
	const sheet = workbook.addWorksheet(
		'TRACE_' +
			t('Regulations', {
				ns: 'features/regulations',
				keyPrefix: 'RegulationsList',
			}),
	);

	const columnsXLRender = getColumnsXLRender(t);
	const columnsXL: XLColumn[] = mergeColumnsExcel(columns, columnsXLRender);

	const arrColWidth = columnsXL.map(x => x.xlWidth ?? 25);
	const strPageName = '';

	renderHeaderXL(workbook, sheet, arrColWidth, strPageName, t);

	let intRowCount = 4;
	let row = sheet.getRow(intRowCount);
	row.alignment = {wrapText: true, vertical: 'top'};
	row.font = {
		bold: true,
		name: 'Porsche Next TT',
		size: 10,
		color: {argb: 'FFFFFFFF'},
	};

	sheet.addTable({
		name: 'Regulations',
		ref: 'B' + String(intRowCount),
		style: {
			showRowStripes: true,
		},
		columns: columnsXL,
		rows: [],
	});

	const table = sheet.getTable('Regulations');

	intRowCount++;

	if (filtRegulation.length === 0) {
		table.addRow(new Array(columnsXL.length).fill(''));
		intRowCount++;
	}

	for (let ii = 0; ii < filtRegulation.length; ii++) {
		const iRegulation = filtRegulation[ii];

		row = sheet.getRow(intRowCount);
		row.alignment = {wrapText: true, vertical: 'top'};
		const renderedXLRow = columnsXL.map(x => {
			const xlRenderFnDef = () => '';
			const xlRenderFn = x.xlRender ?? xlRenderFnDef;
			return xlRenderFn(iRegulation);
		});
		table.addRow(renderedXLRow);

		intRowCount++;

		const arrAttach = iRegulation.attachments ?? [];
		arrAttach.forEach(iAttach => {
			intRowCount = renderRowItemAsLinkXL(
				intRowCount,
				iAttach.file?.fileName ?? iAttach.attachmentId,
				iAttach.file?.uri ?? '',
				'C',
				1,
				sheet,
				table,
				t,
			);
		});
	}

	table.commit();
	const strZipName = t('Regulations', {
		ns: 'features/regulations',
		keyPrefix: 'RegulationsList',
	});
	await createZIPXL(workbook, strZipName, t);
};
